import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever the route changes
    // This fixes the issue where pages were opening scrolled to bottom
    
    // Option 1: Instant scroll (recommended for immediate response)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    // Option 2: Smooth scroll (uncomment to enable animated scrolling)
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
    
    // Option 3: Simple scroll (fallback for older browsers)
    // window.scrollTo(0, 0);
    
  }, [pathname]);

  return null;
}

export default ScrollToTop; 